import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLabels, createLabel /* , deleteLabel */ } from '../../redux/labelStore/action';

export function LabelManager() {
  const dispatch = useDispatch();
  const { data: labels, status } = useSelector((s) => s.label);
  const [name, setName] = useState('');
  const [color, setColor] = useState('#FFFFFF');

  useEffect(() => {
    if (status === 'idle') dispatch(fetchLabels());
  }, [dispatch, status]);

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    // Rely on request interceptor to attach auth and business headers;
    // server infers userId and businessId from token/header.
    await dispatch(createLabel({
      labelName: name.trim(),
      color: color.replace('#',''),
    }));
    setName('');
  };

  /* const handleDelete = (id) => {
    if (!window.confirm('Delete this label?')) return;
    dispatch(deleteLabel(id));
  }; */

  return (
    <div>
      <form className="row g-2 align-items-end mb-3" onSubmit={handleAdd}>
        <div className="col-7">
          <label className="form-label" htmlFor="labelName">Label name</label>
          <input id="labelName" className="form-control" value={name} onChange={(e)=>setName(e.target.value)} placeholder="e.g., VIP" required />
        </div>
        <div className="col-3">
          <label className="form-label" htmlFor="labelColor">Color</label>
          <input id="labelColor" type="color" className="form-control form-control-color" value={color} onChange={(e)=>setColor(e.target.value)} />
        </div>
        <div className="col-2">
          <button type="submit" className="btn btn-primary w-100" disabled={status==='loading'}>Add</button>
        </div>
      </form>

      <div className="table-responsive">
        <table className="table table-sm align-middle">
          <thead>
            <tr>
              <th style={{width: '36px'}}></th>
              <th>Name</th>
              {/* <th className="text-end" style={{width: '100px'}}>Actions</th> */}
            </tr>
          </thead>
          <tbody>
            {labels.map((t)=> (
              <tr key={t._id}>
                <td>
                  <span className="d-inline-block rounded-circle" style={{ width: 16, height:16, backgroundColor: `#${(t.color||'FFFFFF').replace('#','')}`}} />
                </td>
                <td>{t.labelName}</td>
                {/* <td className="text-end">
                  <button className="btn btn-sm btn-outline-danger" onClick={()=>handleDelete(t._id)}>Delete</button>
                </td> */}
              </tr>
            ))}
            {labels.length === 0 && (
              <tr><td colSpan={3} className="text-muted">No labels yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
